import { ko } from 'date-fns/locale';
import { forwardRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import styled from 'styled-components';

const Datepicker = ({ startDate, setStartDate, endDate, setEndDate }) => {
  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <StyledCustomInput onClick={onClick} ref={ref}>
      {value}
    </StyledCustomInput>
  ));

  const onChange = ({ data, position }) => {
    if (position === 'start' && data <= endDate) {
      setStartDate(data);
    }
    if (position === 'end' && data >= startDate && data <= new Date()) {
      setEndDate(data);
    }
  };

  return (
    <Block>
      <ReactDatePicker
        selected={startDate}
        onChange={data => onChange({ data, position: 'start' })}
        customInput={<CustomInput />}
        dateFormat="yyyyMMdd"
        locale={ko}
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
            }}
          >
            <button
              style={{ border: 'none', marginRight: 10, cursor: 'pointer' }}
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
            >
              {'<'}
            </button>
            <div style={{ marginRight: 5 }}>{`${date.getFullYear()}년`}</div>
            <div>{`${date.getMonth() + 1}월`}</div>
            <button
              style={{ border: 'none', marginLeft: 10, cursor: 'pointer' }}
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
            >
              {'>'}
            </button>
          </div>
        )}
      />
      <div>-</div>
      <ReactDatePicker
        selected={endDate}
        onChange={data => onChange({ data, position: 'end' })}
        customInput={<CustomInput />}
        dateFormat="yyyyMMdd"
        locale={ko}
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
            }}
          >
            <button
              style={{ border: 'none', marginRight: 10, cursor: 'pointer' }}
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
            >
              {'<'}
            </button>
            <div style={{ marginRight: 5 }}>{`${date.getFullYear()}년`}</div>
            <div>{`${date.getMonth() + 1}월`}</div>
            <button
              style={{ border: 'none', marginLeft: 10, cursor: 'pointer' }}
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
            >
              {'>'}
            </button>
          </div>
        )}
      />
    </Block>
  );
};

const Block = styled.div`
  display: flex;
`;

const StyledCustomInput = styled.div`
  padding: 3px 5px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  background-color: #fff;
  font-size: 12px;
  cursor: pointer;
`;

export default Datepicker;
